// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Interfaces and types
import {
  IGetParkingIssuesRes,
  IGetParkingIssuesDetailsRes,
  IDeleteParkingIssuesParams,
  IDeleteParkingIssuesRes,
  IUpdateParkingIssuesBodyWithParams,
  IUpdateParkingIssuesRes,
  ICreateParkingIssueFileRes,
} from 'types/parkingIssuesTypes';
import { IResMessage, TQueryParams } from 'types/appTypes';

export const getParkingIssues = (params: TQueryParams) => {
  return xhr.get<IGetParkingIssuesRes, IGetParkingIssuesRes>(`${ENDPOINTS.parkingIssues}`, {
    params,
  });
};

export const getParkingIssueDetails = (id: number) => {
  return xhr.get<IGetParkingIssuesDetailsRes, IGetParkingIssuesDetailsRes>(
    `${ENDPOINTS.parkingIssues}/${id}`,
  );
};

export const updateParkingIssue = ({ id, body }: IUpdateParkingIssuesBodyWithParams) => {
  return xhr.patch<IUpdateParkingIssuesRes, IUpdateParkingIssuesRes>(
    `${ENDPOINTS.parkingIssues}/${id}`,
    body,
  );
};

export const deleteParkingIssue = ({ id }: IDeleteParkingIssuesParams) => {
  return xhr.delete<IDeleteParkingIssuesRes, IDeleteParkingIssuesRes>(
    `${ENDPOINTS.parkingIssues}/${id}`,
  );
};

export const addParkingIssueFile = (file: FormData) => {
  return xhr.post<ICreateParkingIssueFileRes, ICreateParkingIssueFileRes>(
    `${ENDPOINTS.parkingIssueFiles}`,
    file,
  );
};

export const deleteParkingIssueFile = (id: string) => {
  return xhr.delete<IResMessage, IResMessage>(`${ENDPOINTS.parkingIssueFiles}/${id}`);
};
